import { createFileRoute, redirect } from "@tanstack/react-router"
import { isAdmin } from "@/hooks/useAuth"

export const Route = createFileRoute("/admin/user-groups")({
  beforeLoad: () => {
    if (!isAdmin()) {
      throw redirect({ to: "/admin" })
    }
  },
})
